import { useEffect, useState, useCallback } from "react";
import React from 'react';
import Select from "react-select";
import { Create } from "./Create";
import { Update } from "./Update";
import { Delete } from "./Delete";
import SuiBox from "components/SuiBox";
import { useForm } from 'react-hook-form';
import SuiTypography from "components/SuiTypography";
import ActionRequestButtons from "examples/Requestor/components/ActionRequestButtons";

const customStyles = {
  loadingIndicator: (base) => ({
    ...base,
    color: "#ff6347",
    fontSize: '6px',
    marginRight: '1rem'
  }),
};

export const ManagePersal = React.memo(({ setApiRequestObj }) => {
  const { register, formState: { errors }, reset, setValue } = useForm();
  const requestorRoleName = localStorage.getItem('roleName');

  const rolePermittedOptions = {
    "Junior Manager": {
      role: ["Create", "Update", "Delete"]
    },
    "Feeder Junior Manager": {
      role: ["Create", "Update", "Delete"]
    },
    "General Manager": {
      role: ["Create", "Update", "Delete"]
    },
    "Feeder General Manager": {
      role: ["Create", "Update", "Delete"]
    },
    "Admin": {
      role: ["Create", "Update", "Delete"]
    }
  };

  const [userRoleName, setUserRoleName] = useState('');
 
  return (
    <>
      <SuiBox mt={4} mb={2} lineHeight={1}>
        <SuiTypography variant="h6">Persal Request</SuiTypography>
        <SuiBox position="relative">
          <Select
            id={`roleName`}
            key={`roleName`}
            isSearchable={false}
            classNamePrefix="custom-select"
            register={register('roleName')}
            className="select-control select-one select-with-html"
            placeholder={`Select the persal request you want to initiate`}
            options={rolePermittedOptions[requestorRoleName].role.map((role) => ({ value: role, label: role })) || []}
            onChange={(e) => { setUserRoleName(e.value); userRoleName !== e.value ? reset() : ''; setValue('roleName', e.value); }}
          />
        </SuiBox>
      </SuiBox>

      {userRoleName === 'Create' && <Create setApiRequestObj={setApiRequestObj} register={register} />}
      {userRoleName === 'Update' && <Update setApiRequestObj={setApiRequestObj} register={register} />}
      {userRoleName === 'Delete' && <Delete setApiRequestObj={setApiRequestObj} register={register} />}
    </>
  )
});
